import { useState } from 'react';
import { Toast } from 'primereact/toast';
import {
  ResourceServerList,
  ResourceServerCreateDialog,
  ResourceServerEditDialog,
} from '@authifi/clique-react-ui';
import type { ResourceServer } from '@authifi/clique-react-ui';
import { useEntityToasts } from '../hooks/useEntityToasts';

export function ResourceServersPage() {
  const { toastRef, notifyCreated, notifyUpdated, notifyDeleted } =
    useEntityToasts('Resource Server');
  const [showCreateDialog, setShowCreateDialog] = useState(false);
  const [editingResourceServer, setEditingResourceServer] = useState<ResourceServer | null>(null);

  return (
    <div>
      <Toast ref={toastRef} />
      <h2 className="text-2xl font-semibold text-[var(--clique-fg)] mb-2">Resource Servers</h2>
      <p className="text-[var(--clique-fg-muted)] mb-6">
        Manage resource servers that organize permissions and access roles.
      </p>

      <ResourceServerList
        onResourceServerSelect={setEditingResourceServer}
        onCreateResourceServer={() => setShowCreateDialog(true)}
      />

      <ResourceServerCreateDialog
        visible={showCreateDialog}
        onHide={() => setShowCreateDialog(false)}
        onCreated={(rs) => notifyCreated(rs.name)}
      />

      <ResourceServerEditDialog
        visible={editingResourceServer !== null}
        onHide={() => setEditingResourceServer(null)}
        resourceServer={editingResourceServer}
        onUpdated={(rs) => notifyUpdated(rs.name)}
        onDeleted={notifyDeleted}
      />
    </div>
  );
}
